

export const canActivateUser = (user) => ['inactive', 'unverified', 'blocked'].includes(user.status)
export const canEditUser = (user) => ['inactive', 'active'].includes(user.status)
export const canDeactivateUser = (user) => ['unverified', 'active'].includes(user.status)
export const canBlockUser = (user) => ['inactive'].includes(user.status)
export const canDeleteUser = (user) => ['blocked'].includes(user.status)
